import { Tooltip } from "antd"
import { getImage, getThemedImage, getTranslated, isHTMLString } from "../../utils/CommonUtils"
import parse from 'html-react-parser'
import { useState } from "react"
import { useSelector } from "react-redux"

const ImageGroup = (props) => {

    const dict = useSelector(state => state.common.dict)

    const getSrcImage = (image) => {

        if (image?.value === undefined) return null

        if (image.value === "true") {
            return props.hoveredRow
                ? getThemedImage(`circleborder_${image.imageIcon}`)
                : getThemedImage(`circle_${image.imageIcon}`)
        }

        return props.hoveredRow
            ? getThemedImage(image.imageIcon)
            : getThemedImage(`dark_${image.imageIcon}`)
    }

    const CustomSingleImage = ({ image, srcImg }) => {

        const [innerVisible, setInnerVisible] = useState(false)
        const [outerVisible, setOuterVisible] = useState(false)

        return <span style={{ position: "relative" }}>
            <Tooltip
                title={isHTMLString(image.help) ? parse(image.help) : getTranslated(dict, image.help)}
                open={outerVisible && !innerVisible} // Hide outer tooltip when inner is active
                onOpenChange={(visible) => setOuterVisible(visible)}
                arrow={{ pointAtCenter: true }}
            >
                <img
                    src={srcImg}
                    style={{
                        visibility: image.value === "null" ? "hidden" : "",
                        // opacity: image.value === "true" ? 1 : 0.5,
                        height: image.height || props.height || 25,
                        width: image.width || props.width || 25
                    }}
                    alt={image.id}
                />
                {(image.secondaryIcon) ?
                    <Tooltip
                        open={innerVisible}
                        onOpenChange={(visible) => setInnerVisible(visible)}
                        title={(isHTMLString(image.secondaryHelp) ? parse(image.secondaryHelp) : getTranslated(dict, image.secondaryHelp))}
                        arrow={{ pointAtCenter: true }}
                    >
                        <img
                            src={getImage(image.secondaryIcon)}
                            alt="Active Status"
                            className="status-indicator"
                            onMouseEnter={(e) => {
                                e.stopPropagation()
                                setInnerVisible(true)
                                // setOuterVisible(false) // Hide outer tooltip
                            }}
                            onMouseLeave={() => setInnerVisible(false)}
                        />
                    </Tooltip>
                    : <></>}
            </Tooltip>
        </span>
    }

    return <div className={`group-img-container ${props.className}`}>
        {props.enum.map((image) => {
            const srcImg = getSrcImage(image)

            return (srcImg !== null) ?
                <CustomSingleImage image={image} srcImg={srcImg} key={image.id}/>
                :
                <span style={{ width: props.width || 25, height: props.height || 25 }} />
        })}
    </div>
}

export default ImageGroup